interface BackendColorScale {
  id: number;
  sHue: number;
  eHue: number;
}

export function getBackendColorScaleFromFrontend(
  frontendColorScale: string
): BackendColorScale {
  let colorScale = { id: 0, sHue: 60, eHue: 0 };

  switch (frontendColorScale) {
    case 'yellow to red':
      colorScale = { id: 0, sHue: 60, eHue: 0 };
      break;
    case 'green, yellow to red':
      colorScale = { id: 1, sHue: 120, eHue: 0 };
      break;
    case 'yellow to green':
      colorScale = { id: 2, sHue: 60, eHue: 120 };
      break;
    case 'lightblue to blue':
      colorScale = { id: 3, sHue: 180, eHue: 240 };
      break;
    case 'purple to blue':
      colorScale = { id: 4, sHue: 300, eHue: 240 };
      break;
    case 'purple to red':
      colorScale = { id: 5, sHue: 300, eHue: 360 };
      break;
    case 'green to teal':
      colorScale = { id: 7, sHue: 120, eHue: 180 };
      break;
    case 'green, red, green, teal, blue to purple':
      colorScale = { id: 8, sHue: 0, eHue: 300 };
      break;
    case 'yellow to teal':
      colorScale = { id: 9, sHue: 60, eHue: 180 };
      break;
  }

  return colorScale;
}

export function getFrontendColorScaleFromBackend(
  backendColorScale: BackendColorScale | undefined
): string {
  // Handle case where backendColorScale is undefined (for new reports)
  if (!backendColorScale) {
    return 'yellow to red'; // Default value
  }

  const { sHue, eHue } = backendColorScale;
  const frontendColorScale = 'yellow to red';

  if (sHue === 60 && eHue === 0) {
    return 'yellow to red';
  }

  if (sHue === 120 && eHue === 0) {
    return 'green, yellow to red';
  }

  if (sHue === 60 && eHue === 120) {
    return 'yellow to green';
  }

  if (sHue === 180 && eHue === 240) {
    return 'lightblue to blue';
  }

  if (sHue === 300 && eHue === 240) {
    return 'purple to blue';
  }

  if (sHue === 300 && eHue === 360) {
    return 'purple to red';
  }

  if (sHue === 120 && eHue === 180) {
    return 'green to teal';
  }

  if (sHue === 0 && eHue === 300) {
    return 'green, red, green, teal, blue to purple';
  }

  if (sHue === 60 && eHue === 180) {
    return 'yellow to teal';
  }

  return frontendColorScale;
}
